<template>
  <div class="updatePasswordContent" v-if="isLogined">
    <div class="title">修改密码</div>
    <div class="oldPassword"><div>原密码：</div><input type="password" placeholder="请输入原密码" v-model="form.currentPassword"></div>
    <div class="newPassword"><div>新密码：</div>
      <input :type="passwordType" placeholder="请输入新密码" v-model="form.newPassword" @keyup="toCheckPassword">
      <img v-if="passwordType === 'password'" src="https://file-sz.fjjykj.com.cn/Supply/se21a0a57445b47f30e25aa15ddae8d94.png" @click="handlePassword">
      <img v-else src="https://file-sz.fjjykj.com.cn/Supply/s863608c680ccd0900caff867a42cf508.png" @click="handlePassword">    
    </div>
    <div class="passwordStrength">
      <div class="title">强度：</div>      
      <div class="pw-strength">
        <div  :class="(passwordLen<6?' pw-defule':(passwordVal==1?' pw-weak':(passwordVal==2?' pw-medium':' pw-strong')))">
            <div class="pw-bar"></div>
            <div class="pw-bar-on"></div>
            <div class="pw-txt">
              <span>弱</span>
              <span>中</span>
              <span>强</span>
            </div>
          </div>   
      </div>
  </div>
    <div class="confirmPassword"><div>确认密码：</div><input type="password" placeholder="请输入确认密码" v-model="form.password_confirmation"></div>
    <div class="savePassword"> <input type="button" value="保存密码"  :loading="isLoading" :disabled="isReset" @click="submitForm"></div>
  </div>
  <div class="updatePasswordContent1" v-else>
    <div @click="toLogin()">亲,请先登陆</div>
  </div>
</template>
<style>
@import '../../../styles/updatePassword.css';
</style>
<script>
import api from '@/api'
import { mapState} from 'vuex'
export default {
  name: 'passwordReset',
  data() {
    return {
      isLoading: false,
      isReset: false,
      passwordLen:0,
      passwordVal:0,
      passwordType:'password',
      form: {
        currentPassword: '',
        newPassword: '',
        password_confirmation: ''
      },
      rules: { }
    }
  },
  computed: {
      ...mapState(['isLogined'])     
    },
  methods: {
    handlePassword() {
      this.passwordType === 'password'
        ? (this.passwordType = '')
        : (this.passwordType = 'password')    
    },
    toLogin() {
      this.$router.push({ name: 'userLogin' })
      },
    toCheckPassword () {
      var txt = $.trim(this.form.newPassword);//输入框内容 trim处理两端空格
      var len = txt.length;
      this.passwordLen=len;
      var num = /\d/.test(txt);//匹配数字
      var big = /[A-Za-z]/.test(txt);//大小写字母
      var corps = /\W/.test(txt);//特殊符号
      var val = num + big + corps; //三个组合
      this.passwordVal = val;
    },
    submitForm() {
          if(this.form.currentPassword=='')
          {
            this.$message({ message: '原密码不可为空', type: 'error', customClass: 'c-msg' })
            return;
          }
          if(this.form.newPassword=='')
          {
            this.$message({ message: '新密码不可为空', type: 'error', customClass: 'c-msg' })
            return;
          }
          if(this.form.password_confirmation=='')
          {
            this.$message({ message: '确认密码不可为空', type: 'error', customClass: 'c-msg' })
            return;
          }
          var txt = this.form.newPassword;//输入框内容 trim处理两端空格
          var len = txt.length;
          var num = /\d/.test(txt);//匹配数字
          var big = /[A-Za-z]/.test(txt);//大小写字母
          var corps = /\W/.test(txt);//特殊符号
          var val = num + big + corps; //三个组合
          if (len < 6) { 
            this.$message({ message: '密码长度至少需要6位数', type: 'error', customClass: 'c-msg' })
            return;
          }
          if (val != 3) {
            this.$message({ message: '密码强度太低,需要数字、字母、特殊字符中三个的组合', type: 'error', customClass: 'c-msg' })
            return;
          }
                    
                                    
          if(this.form.newPassword!=this.form.password_confirmation)
          {
            this.$message({ message: '新密码和确认密码不一致', type: 'error', customClass: 'c-msg' })
            return;
          }
          this.isLoading = true
        
          api.put('api/services/app/FrontendUser/UpdateUserPassword', this.form).then(response => {
            this.isLoading = false
            if (response.data.success === true) {
              this.isReset = true
              this.$message({
                message: '密码修改成功。',
                type: 'success',
                customClass: 'c-msg'
              })
            } else {
              this.$message({
                message: '原密码错误。',
                type: 'error',
                customClass: 'c-msg'
              })
            }
          }).catch(error => {
            this.isLoading = false
           
            this.$message({
              message: '原密码错误。',
              type: 'error',
              customClass: 'c-msg',
              duration: 1000,
              showClose: true
            })
            Promise.reject(error)
          })
    },
  }
}
</script>


// WEBPACK FOOTER //
// Reset.vue?52853401